import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from "@angular/router";
import { Observable, from } from "rxjs";

import { DbService } from "./db.service";

@Injectable({
    providedIn: 'root'
})
export class MapDashboardResolver implements Resolve<any> {

    constructor(private db: DbService) { }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return from(this.db.getMapDashboardData(route.params.id));
    }
}
